export default "__VITE_ASSET__B_8ntb$K__"